import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for managing workflow information
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create();

    const getSystemConfig = () => api.getAnonymous(ApiPaths.GET_SYSTEM_CONFIG);

    // Return back a collection of functions
    return { getSystemConfig }
}

// let's return back our create method as the default.
export default {
    create
}

